import React from 'react';

const LandingDisclaimer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="bg-[#f5f5f5] px-4 py-6 text-center">
      <p className="text-xs text-[#999] mb-2">{currentYear} © All rights reserved.</p>
      <p className="text-[0.65rem] text-[#aaa] max-w-[600px] mx-auto leading-relaxed">
        DISCLAIMER: Results may vary from person to person. By continuing, you agree to with our Terms of Service, Privacy Policy, Money-Back Policy, Subscription terms, Cookie policy. Careeristo's content is for educational purposes only and is not professional career or financial advice. Consult qualified professionals for career and financial decisions.
      </p>
    </div>
  );
};

export default LandingDisclaimer;
